// extracted by mini-css-extract-plugin
module.exports = {"section":"opportunityZone_section__j3_dv","title":"opportunityZone_title__3IyrA","button":"opportunityZone_button__mY3Fm"};